import { logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { analytics } from '@/lib/firebase';

type Params = Record<string, unknown>;

function baseParams(): Params {
  if (typeof window === 'undefined') return {};
  return {
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_referrer: document.referrer || undefined,
    language: document.documentElement.lang || navigator.language,
  };
}

export function trackEvent(name: string, params: Params = {}): void {
  if (!analytics) return;
  try {
    logEvent(analytics, name, { ...baseParams(), ...params });
  } catch (e) {
    console.warn('[analytics] trackEvent failed', name, e);
  }
}

export function setAnalyticsUser(uid: string | null, props: Params = {}): void {
  if (!analytics) return;
  try {
    setUserId(analytics, uid ?? null);
    if (uid && Object.keys(props).length > 0) {
      setUserProperties(analytics, props as Record<string, string>);
    }
  } catch (e) {
    console.warn('[analytics] setAnalyticsUser failed', e);
  }
}
